import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import withFieldsCheck from "@clarion/foundation/dist/Helpers/containers/WithFieldsCheck";
import Chevron from "@clarion/foundation/dist/Theming/icons/Chevron";
import { formatSentenceCase } from "@clarion/foundation/dist/Utils/formatingUtils";
import "./index.css";
const Breadcrumb = ({
  addJsonLdData,
  protocol,
  sitecoreContext,
  fields,
  t
}) => {
  const pageBreadcrumbTitle = sitecoreContext.route.fields?.BreadcrumbTitle?.value;
  const targetHostname = sitecoreContext?.siteSettings?.targetHostname;
  const global = useSelector(state => state.global);
  const buildBreadcrumbs = fieldsParam => {
    const breadcrumbList = [];
    const getItem = (item = {}) => {
      const isValidItem = item.breadcrumbTitle && item.itemUrl; // Folder items should be invalid (due to falsy breadcrumbTitle)

      if (isValidItem) {
        breadcrumbList.push(item);
        if (!item.itemParent) {
          return; // No more items, end recursion
        }
      }
      getItem(item.itemParent);
    };
    getItem(fieldsParam);
    return breadcrumbList.reverse();
  };
  const breadcrumbs = buildBreadcrumbs(fields);
  const parentPage = breadcrumbs[breadcrumbs.length - 2];
  const jsonldData = JSON.stringify((() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": []
    };
    breadcrumbs.forEach((breadcrumb, i) => {
      const url = breadcrumb.itemUrl.replace(protocol, "").replace(targetHostname, "");
      data.itemListElement.push({
        "@type": "ListItem",
        "position": i + 1,
        "name": breadcrumb.itemName,
        "item": protocol + targetHostname + url
      });
    });
    return data;
  })());
  return /*#__PURE__*/React.createElement(Fragment, null, addJsonLdData && /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, jsonldData)), breadcrumbs.length > 1 && /*#__PURE__*/React.createElement("nav", {
    className: "breadcrumb wrapper",
    "aria-label": t("Breadcrumb")
  }, global.isMobile ? /*#__PURE__*/React.createElement("a", {
    className: "breadcrumb__link",
    href: parentPage?.itemUrl
  }, /*#__PURE__*/React.createElement(Chevron, {
    className: "breadcrumb__prev-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "breadcrumb__text general-link general-link--small general-link--coral"
  }, formatSentenceCase(parentPage?.breadcrumbTitle))) : /*#__PURE__*/React.createElement("ol", null, (breadcrumbs || []).map((item, i) => {
    const isCurrentPage = item.breadcrumbTitle === pageBreadcrumbTitle;
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: "breadcrumb__list-item"
    }, isCurrentPage && item.breadcrumbTitle ? /*#__PURE__*/React.createElement("a", {
      className: "breadcrumb__link general-link general-link--small general-link--coral",
      href: item.itemUrl,
      "aria-current": "page"
    }, formatSentenceCase(item.breadcrumbTitle)) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("a", {
      className: "breadcrumb__link general-link general-link--small general-link--coral",
      href: item.itemUrl
    }, formatSentenceCase(item.breadcrumbTitle)), /*#__PURE__*/React.createElement(Chevron, {
      className: "breadcrumb__next-icon"
    })));
  }))));
};
const BreadcrumbWithFieldsCheck = withFieldsCheck(Breadcrumb);
const BreadcrumbWithFieldsCheckAndTranslation = withTranslation()(BreadcrumbWithFieldsCheck);
export default withSitecoreContext()(BreadcrumbWithFieldsCheckAndTranslation);